<template>
    <div>

        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />

        <div class="container-fluid" :style="paddinBottomDinamic">
            <div class="row">

                <div class="col-6">
                    <Form ref="ABC" @submit="postAnotacao">

                        <div class="mt-2">
                            <label class="form-label">Selecione o tipo de anotação</label>
                            <vue-select v-model="tipoAnotacaoSelected" :options="tipoAnotacao"
                                :label-by="formatNmTipoAnotacao" placeholder="Selecione o tipo de anotação"
                                search-placeholder="Pesquise" searchable close-on-select clear-on-select :min="1"
                                class="form-control shadow-v2" :class="{ filled: tipoAnotacaoSelected.idTipoAnotacao > 0 }">
                            </vue-select>

                            <Field name="idTipoAnotacao" label="Tipo Anotação" type="hidden" rules="min_value:1" v-model="AnotacaoCrud.idTipoAnotacao" />

                            <ErrorMessage name="idTipoAnotacao" class="form-error" v-show="showErrorMessage" />
                        </div>

                        <div class="mt-3">
                            <label class="form-label">Anotação</label>
                            
                            <ckeditor :editor="editor" v-model="AnotacaoCrud.dsAnotacao"></ckeditor>


                            <Field name="dsAnotacao" label="Descrição da Anotação" type="hidden" rules="required"
                                   v-model="AnotacaoCrud.dsAnotacao" />
                            <ErrorMessage name="dsAnotacao" class="form-error" v-show="showErrorMessage" />
                        </div>

                        <div class="mt-3">

                            <input-upload ref="inputuploadv2" :url-upload="urlAnotacaoAnexoUpload" @on-save="uploadFile" :labelText="'Anexo de Anotações'" />
                            <Field name="urlAnexo" label="Anexo" type="hidden"  v-model="AnotacaoCrud.urlAnexo" />

                        </div>

                        <div class="mt-3">
                            <button type="submit" class="btn btn-red" style="width: 100%" form="form"
                                v-on:click="postAnotacao">
                                <i class="fas fa-save pe-2"></i>
                                Salvar Anotação</button>
                        </div>

                    </Form>
                </div>


                <div class="col-6">
                    
                    <div class="d-flex">                                        
                        <div class="flex-fill">
                            <vue-select v-model="tp_anotacao_filtro" :options="tipoAnotacao_filtro"
                                        :label-by="formatNmTipoAnotacao" placeholder="Selecione o tipo de anotação"
                                        search-placeholder="Pesquise" searchable close-on-select clear-on-select :min="1"
                                        class="form-control shadow-v2 mt-35" :class="{ filled: tipoAnotacaoSelected.idTipoAnotacao > 0 }">
                            </vue-select>

                        </div>
                        <div class="flex-fill ms-3">
                            <InputSearch v-model="filtroBusca" placeholder="Pesquise uma anotação" class="mt-35" @keypress.enter="(reloadGrid = (reloadGrid + 1))" />
                        </div>
                    </div>

                    <RegistroGrid :id="'registros_anotacoes'" :idOcorrencia="idOcorrencia" :reloadGrid="reloadGrid" :filtroBusca="filtroBusca"
                        class="mt-1 ms-3 me-3" :customHeightRegGrid="lowHeightPage" :customHeightRegGridNoPage="lowHeightNoPage"
                        :customSizeWid="'width:103%;left:0'" :cdTipoAnotacao="tp_anotacao_filtro.cdTipoAnotacao"
                        :btnSizeDown="btnSizeDinamic" :customBtnBaixar="'min-width: 80px;margin-left: 5px;'" />
                </div>

            </div>

        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import RegistroGrid from '@/views/Modais/Ocorrencia/Grids/Registros_Grid.vue'
    import InputSearch from '../../../../components/App/Input_Search.vue'
    import InputUpload from '../../../../components/App/Input_Upload.vue'
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import CKEditor from '@ckeditor/ckeditor5-vue';

    export default {
        name: 'Anotações',
        components: {
            'vue-select': VueNextSelect,
            OcorrenciaInfo,
            RegistroGrid,
            InputSearch,
            InputUpload,
            ckeditor: CKEditor.component
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                editor: ClassicEditor,
                ocorrencia: {},

                tipoAnotacao: [],
                tipoAnotacaoSelected: { idTipoAnotacao: 0 },
                tp_anotacao_filtro: { idTipoAnotacao: 0, cdTipoAnotacao: 0 },

                tipoAnotacao_filtro: [],

                AnotacaoCrud: {
                    idTipoAnotacao: 0,
                    idOcorrencia: 0,
                    dsAnotacao: '',
                    urlAnexo: ''
                },


                // file: null,
                // uploadSucesso: false,
                anotacoes: [],

                filtro: [
                    { active: true },
                ],

                filtroBusca: '',
                
                checkedNames: [],
                reloadGrid: 0,
                showErrorMessage: false,
                urlAnotacaoAnexoUpload: process.env.VUE_APP_ROOT_COMERCIAL_API + '/Anotacao/PostUploadAnexo',
                lowHeightPage: '',
                lowHeightNoPage: '',
                btnSizeDinamic: '',
                paddinBottomDinamic: '',
                dinamicWidTable: '',
                heightBox: '',
            }
        },
        computed: {},
        methods: {

            updatebtnSizeDinamic() {
                if (window.innerWidth >= 3500) {
                    this.btnSizeDinamic = 'width:25%;';
                } else {
                    this.btnSizeDinamic = 'width:50%;';
                }
            },
            updateLowHeight() {
                if (window.innerWidth <= 1600) {
                    this.lowHeightPage = 'max-height: calc(100vh - 16.5rem);min-height: calc(100vh - 16.5rem);margin-top:0px !important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 8.6rem);min-height: calc(100vh - 8.6rem);margin-top:0px !important';
                }
                else if (window.innerWidth >= 1601) {
                    this.lowHeightPage = 'max-height: calc(100vh - 27rem); min-height: calc(100vh - 27rem); margin-top: 0px!important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 24rem);min-height: calc(100vh - 24rem);margin-top:0px !important';
                }
            },
            zerarInformacoes() {
                this.AnotacaoCrud = {
                    idTipoAnotacao: 0,
                    idOcorrencia: 0,
                    dsAnotacao: '',
                    urlAnexo: '',
                };
                this.tipoAnotacaoSelected = { idTipoAnotacao: 0 }
                this.showErrorMessage = false;

            },
            uploadFile(url) {
                this.AnotacaoCrud.urlAnexo = url;

            },
            formatNmTipoAnotacao(tipoAnotacao) {
                return tipoAnotacao.dsTipoAnotacao;
            },
            setAnotacao(result) {
                return result;
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                })
            },
            getTipoAnotacao() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/TipoAnotacao/Get?cdOrigem=' + 8, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    var item_todos = {
                        "idTipoAnotacao": 0,
                        "idOrigem": 0,
                        "cdTipoAnotacao": 0,
                        "dsTipoAnotacao": "Todos"
                    };
                    response.data.data.rows.unshift(item_todos);
                    $this.tipoAnotacao = response.data.data.rows;
                    $this.tipoAnotacao_filtro = response.data.data.rows;
                })
            },
            postAnotacao() {
                let $this = this;

                $this.$refs.ABC.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            $this.AnotacaoCrud.idOcorrencia = $this.idOcorrencia;

                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Anotacao/PostAnotacaoOcorrencia', $this.AnotacaoCrud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.AnotacaoCrud.idTipoAnotacao = 0;
                                    $this.AnotacaoCrud.dsAnotacao = '';

                                    $this.tipoAnotacaoSelected = { idTipoAnotacao: 0 };

                                    $this.reloadGrid += 1;

                                    $this.zerarInformacoes();
                                    $this.$refs.inputuploadv2.resetVariaveis();

                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });

                            $this.showErrorMessage = false;


                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatorios';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        created() {
        },
        mounted() {
            this.getOcorrencia();
            this.getTipoAnotacao();
            this.updateLowHeight();
            /*this.updateLowHeightNoPage();*/
            this.updatebtnSizeDinamic();

            window.addEventListener('resize', this.updateLowHeight);
            /*window.addEventListener('resize', this.updateLowHeightNoPage);*/
            window.addEventListener('resize', this.updatebtnSizeDinamic);
        },
        updated() {
            this.updateLowHeight();
            /*this.updateLowHeightNoPage();*/
            this.updatebtnSizeDinamic();

        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia(newVal);
            },
            tipoAnotacaoSelected(newVal, oldVal) {
                this.AnotacaoCrud.idTipoAnotacao = newVal.idTipoAnotacao;
            },
            tp_anotacao_filtro(newVal, oldVal) {
                this.reloadGrid += 1;
            },
        },
    }

</script>

<style scoped lang="scss">
    .mt-35 {
        margin-top: 30px;
    }

    .file-campo {
        border: 1px dashed #f4f4f4;
    }

    .btn-green {
        font-weight: 700;
        border-radius: 5px !important;
    }

    .btn-red {
        border-radius: 5px !important;
    }



    .line-card {
        //border-radius: 10px 0px 0px 10px;
        max-width: 10px;
        margin-left: -3px;
        margin-top: -1px;
        margin-bottom: -2px;
    }

    .bg-color-red {
        background-color: #AB0000;
    }

    .bg-color-green {
        background: #34A853;
    }

    .icon-size {
        height: 50px;
        color: #34A853;
    }

</style>